import { NextRouter } from 'next/router';

export const hasQueryParams = (router: NextRouter): boolean => {
  const { county, flatType, query, slug, ...queryParams } = router.query;
  return Object.keys(queryParams).length > 0;
};
